<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { Head } from '@inertiajs/inertia-vue3'
import { onMounted, onUnmounted } from 'vue'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  myvalue: Array,
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div>
    <Head title="お問い合わせありがとうございました" />
    <div class="contact bg-afgray py-[110px] lg:py-[130px]">
      <h2 class="font-rift font-bold text-black text-[72px] lg:text-[110px] tracking-[0.015em] text-center">
        Thank you
        <span class="block mt-3 text-[16px] lg:text-[22px] font-bold">お問い合わせありがとうございました</span>
      </h2>
      <div class="mt-10 w-[90%] md:w-[65%] mx-auto text-center text-[3.8vw] md:text-sm leading-10 md:leading-10">
        <p>通常2〜5営業日以内に担当の営業から回答致します。</p>
        <div class="mt-10 max-w-[270px] mx-auto">
          <ButtonRounded style="background-color: #fff" text="お問い合わせトップへ戻る" url="/inquiry/" icon="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>
